<template>
  <mu-card id="weight-input">
    <mu-card-text class="card-style" v-bind:class="{cardHasData: hasData}">
      <div v-if="loading">
        <mu-flexbox class="card-loading-padding" align="center" justify="center">
          <mu-flexbox-item align="center">
            <mu-circular-progress
              :size="60"
              color="#FFFFFF"
              :strokeWidth="5"></mu-circular-progress>
          </mu-flexbox-item>
        </mu-flexbox>
      </div>
      <div v-if="!loading">
        <mu-flexbox v-if="data.no_setting || data.error" class="card-error-padding" justify="center">
          <mu-flexbox-item align="center">
            <div class="card-notice-title"
                 v-text="data.no_height_setting ? $t('message.cardWeightEmptyHeight') : $t('message.cardEmpty')"></div>
            <div>{{$t('message.cardTapPrefix')}}
              <mu-icon v-if="data.no_setting" class="card-icon-error" :size="16" slot="left" value="settings"></mu-icon>
              {{$t('message.cardTapSuffix')}}

            </div>
          </mu-flexbox-item>
        </mu-flexbox>
        <div v-else @click="goToDetail" style="cursor: pointer">
          <span v-show="false">{{hasData = true}}</span>
          <mu-content-block>
            <mu-flexbox>
              <mu-flexbox-item class="card-lite-title" v-text="$t('message.cardLatestReading')"></mu-flexbox-item>
              <mu-flexbox-item align="right">
                <div class="card-large-stat">
                  <span v-text="data.latest"></span>
                  <span v-if="data.userDevice && data.userDevice.userDeviceId !== 0">
                    <img v-tooltip.left="t('message.cardFromDevice') + ' ' +  data.userDevice.nickname"
                         style="position: relative; top: 6px;margin-left: 4px;" width="22"
                         :src="data.userDevice.device.iconWhite"/>
                  </span>
                </div>
              </mu-flexbox-item>
            </mu-flexbox>
          </mu-content-block>
          <mu-content-block>
            <mu-flexbox>
              <mu-flexbox-item class="card-lite-title"
                               v-text="data.lost_weight ? $t('message.cardWeightTotalLoss') : $t('message.cardWeightTotalGain')"></mu-flexbox-item>
              <mu-flexbox-item align="right">
                <div v-text="data.difference"></div>
              </mu-flexbox-item>
            </mu-flexbox>
          </mu-content-block>
          <mu-content-block>
            <mu-flexbox>
              <mu-flexbox-item class="card-lite-title"
                               v-text="data.week_weight.lost_weight ? $t('message.cardWeightLostThisWeek') : $t('message.cardWeightGainedThisWeek')"></mu-flexbox-item>
              <mu-flexbox-item align="right">
                <div v-text="data.week_weight.difference"></div>
              </mu-flexbox-item>
            </mu-flexbox>
          </mu-content-block>
          <mu-content-block>
            <mu-flexbox>
              <mu-flexbox-item class="card-lite-title" v-text="$t('message.cardWeightWaistHipRatio')"></mu-flexbox-item>
              <mu-flexbox-item align="right">
                <div v-text="data.waist_hip_ratio"></div>
              </mu-flexbox-item>
            </mu-flexbox>
          </mu-content-block>
        </div>
      </div>
    </mu-card-text>
    <mu-card-actions>
      <mu-flexbox justify="flex_start" style="height: 48px">
        <svg class="card-left-icon" width="16px" height="14px" viewBox="0 3 16 14" version="1.1"
             xmlns="http://www.w3.org/2000/svg">
          <!-- Generator: Sketch 39.1 (31720) - http://www.bohemiancoding.com/sketch -->
          <desc>Created with Sketch.</desc>
          <defs></defs>
          <path
            d="M15.0274359,4.84740771 C14.8735715,3.69796239 14.1860505,3 13.1481453,3 L7.99995032,3 L2.85178845,3 C1.81394954,3 1.12642845,3.69796239 0.972531032,4.84740771 C0.81863361,5.99685303 0,14.2824828 0,14.2824828 C0,15.3027795 0.841418509,16.1298905 1.87929054,16.1298905 L7.99998344,16.1298905 L14.1207095,16.1298905 C15.1585484,16.1298905 16,15.3027795 16,14.2824828 C15.9999338,14.2824828 15.1813002,5.99682048 15.0274359,4.84740771 L15.0274359,4.84740771 Z M8.04591753,7.64554054 C8.06671538,7.61930062 8.0855924,7.59156313 8.1017869,7.56210019 C8.4607153,7.11289617 9.37125021,5.94541497 9.23897857,5.81603848 C9.13482376,5.71449715 8.33910752,6.12020671 7.76869022,6.43176509 C7.55504867,6.54844484 7.3728026,6.65200463 7.27066796,6.71070262 C7.24397519,6.72362725 7.21910388,6.73863544 7.19456375,6.7548482 C7.18946364,6.75777821 7.18174724,6.76230346 7.18174724,6.76230346 L7.18221089,6.7627918 C7.00413763,6.8859827 6.89405477,7.09443707 6.91432274,7.32330388 C6.92501972,7.44499722 6.97121875,7.55506815 7.0413618,7.64554054 L4.14473213,7.64554054 C4.07713914,7.64554054 4.02236265,7.59169336 4.02236265,7.5252471 C4.02236265,5.52499022 5.67774519,3.89765927 7.71252279,3.89765927 C7.81707501,3.89765927 7.92474029,3.90231474 8.03253803,3.91139779 C8.94949775,3.98884788 9.7994606,4.3991478 10.4257141,5.06663803 C11.05571,5.7380675 11.4026829,6.6112123 11.4026829,7.5252471 C11.4026829,7.59169336 11.3479065,7.64554054 11.2803135,7.64554054 L8.04591753,7.64554054 L8.04591753,7.64554054 Z"
            id="Shape" stroke="none" fill="#69A7D9" fill-rule="evenodd"
            transform="translate(8.000000, 9.564945) scale(-1, 1) translate(-8.000000, -9.564945) "></path>

        </svg>
        <mu-flexbox-item class="left16" v-text="loading ? $t('message.loadingText') : title"></mu-flexbox-item>
        <mu-flexbox-item align="right" v-if="data.no_setting" v-bind:class="{invisible: isOpenSetting || loading}">
          <mu-icon-button
            class="card-bar-icon"
            icon="settings"
            @click.native="openSettings"
          ></mu-icon-button>
        </mu-flexbox-item>
        <mu-flexbox-item align="right" v-if="!data.no_setting" v-bind:class="{invisible: isOpenSetting}">
          <mu-icon-button
            :disabled="loading"
            v-if="!isOpenInput"
            v-tooltip.top="$t('message.addEntryText')"
            class="card-bar-icon"
            :icon="'add'"
            @click.native="openInput"
          ></mu-icon-button>
          <mu-icon-button
            :disabled="loading"
            v-if="isOpenInput"
            class="card-bar-icon"
            :icon="'remove'"
            @click.native="openInput"
          ></mu-icon-button>
        </mu-flexbox-item>
      </mu-flexbox>
    </mu-card-actions>
    <form @submit.prevent="saveSettings" v-if="isOpenSetting">
      <mu-card-text>
        <mu-select-field
          :scroller="scroller"
          v-validate
          data-vv-rules="required"
          data-vv-name="weight_setting"
          data-vv-value-path="inputValue"
          data-vv-as="Weight setting"
          :errorText="errors.first('weight_setting')"
          v-if="data.missing_settings.weight"
          v-model="settings.weight"
          :label="$t('message.unitsPreferencesMeasureWeight')"
          :hintText="$t('message.selectText')"
          :fullWidth="true"
        >
          <mu-menu-item
            v-for="item, index in data.missing_settings.weight"
            :key="'weight-setting-' + index"
            :value="item.preference_id"
            :title="item.unit"
          />
        </mu-select-field>
        <mu-select-field
          :scroller="scroller"
          v-validate
          data-vv-rules="required"
          data-vv-name="height_setting"
          data-vv-value-path="inputValue"
          :errorText="errors.first('height_setting')"
          v-if="data.missing_settings.height"
          v-model="settings.height"
          :label="$t('message.unitsPreferencesMeasureHeight')"
          :hintText="$t('message.selectText')"
          :fullWidth="true"
        >
          <mu-menu-item
            v-for="item, index in data.missing_settings.height"
            :key="'height-setting-' + index"
            :value="item.preference_id"
            :title="item.unit"
          />
        </mu-select-field>
        <mu-select-field
          :scroller="scroller"
          v-validate
          data-vv-rules="required"
          data-vv-name="waist_setting"
          data-vv-value-path="inputValue"
          data-vv-as="Waist setting"
          :errorText="errors.first('waist_setting')"
          v-if="data.missing_settings.waist"
          v-model="settings.waist"
          :label="$t('message.unitsPreferencesMeasureWaist')"
          :fullWidth="true"
          :hintText="$t('message.selectText')"
        >
          <mu-menu-item
            v-for="item, index in data.missing_settings.waist"
            :key="'waist-setting-' + index"
            :value="item.preference_id"
            :title="item.unit"
          />
        </mu-select-field>
      </mu-card-text>
      <mu-card-actions align="right" v-if="isOpenSetting">
        <mu-flat-button
          :label="$t('message.discardText')"
          @click.native="closeSettings"
          class="demo-flat-button"
        />
        <mu-flat-button
          type="submit"
          :disabled="isSaving"
          :label="isSaving ? 'Saving': 'Save'"
          class="demo-flat-button"
        />
      </mu-card-actions>
    </form>
    <form @submit.prevent="saveHeightSettings" v-if="isOpenHeightSetting">
      <mu-card-text>
        <mu-row>
          <mu-col width="100" tablet="50" desktop="50" v-if="height.measure === 'cm'">
            <mu-text-field
              v-validate
              min="0"
              max="272"
              :data-vv-rules="'required|min_value:0|max_value:272'"
              data-vv-name="height_cm"
              data-vv-value-path="inputValue"
              data-vv-as="cm"
              :errorText="errors.first('height_cm')"
              :hintText="$t('message.placeholderText')"
              v-model.number="heightSettings.cm"
              label="cm"
            />
          </mu-col>
          <mu-col width="100" tablet="50" desktop="50" v-if="height.measure === 'ft-in'">
            <mu-text-field
              v-validate
              min="0"
              max="9"
              :data-vv-rules="'required|min_value:0|max_value:9'"
              data-vv-name="height_ft"
              data-vv-value-path="inputValue"
              data-vv-as="ft"
              :errorText="errors.first('height_ft')"
              :hintText="$t('message.placeholderText')"
              v-model.number="heightSettings.ft"
              label="ft"
              :fullWidth="true"
            />
          </mu-col>
          <mu-col width="100" tablet="50" desktop="50" v-if="height.measure === 'ft-in'">
            <mu-text-field
              v-validate
              min="0"
              max="11"
              :data-vv-rules="'required|min_value:0|max_value:11'"
              data-vv-name="height_in"
              data-vv-value-path="inputValue"
              data-vv-as="in"
              :errorText="errors.first('height_in')"
              :hintText="$t('message.placeholderText')"
              v-model.number="heightSettings.in"
              label="in"
              :fullWidth="true"
            />
          </mu-col>
        </mu-row>
      </mu-card-text>
      <mu-card-actions align="right" v-if="isOpenHeightSetting">
        <mu-flat-button
          label="Discard"
          @click.native="closeHeightSettings"
          class="demo-flat-button"
        />
        <mu-flat-button
          @click.native="saveHeightSettings"
          type="submit"
          :disabled="isSaving"
          :label="isSaving ? 'Saving': 'Save'"
          class="demo-flat-button"
        />
      </mu-card-actions>
    </form>
    <transition :css="false" @enter="onToggleEnter" @leave="onToggleLeave">
      <form @submit.prevent="saveReading" v-if="isOpenInput" style="overflow: hidden"
            v-bind:style="{height: computedAuto}">
        <mu-card-text>
          <mu-row>
            <mu-col width="100" tablet="50" desktop="50" v-if="weight.measure === 'kg'">
              <mu-text-field
                v-validate
                min="0"
                max="635"
                data-vv-validate-on="none"
                :data-vv-rules="'required|min_value:0|max_value:635'"
                data-vv-name="kg"
                data-vv-value-path="inputValue"
                data-vv-as="kg"
                :errorText="errors.first('kg')"
                type="number"
                label="KG"
                :hintText="$t('message.placeholderText')"
                v-model.number="model.kg"
                :fullWidth="true"
              />
            </mu-col>
            <mu-col width="100" tablet="50" desktop="50" v-if="weight.measure === 'lbs'">
              <mu-text-field
                v-validate
                min="0"
                max="1400"
                data-vv-validate-on="none"
                :data-vv-rules="'required|min_value:0|max_value:1400'"
                data-vv-name="lbs"
                data-vv-value-path="inputValue"
                data-vv-as="lbs"
                :errorText="errors.first('lbs')"
                type="number"
                label="LBS"
                :hintText="$t('message.placeholderText')"
                v-model.number="model.lbs"
                :fullWidth="true"
              />
            </mu-col>
            <mu-col width="100" tablet="50" desktop="50" v-if="weight.measure === 'st-lbs'">
              <mu-text-field
                v-validate
                data-vv-validate-on="none"
                min="0"
                max="100"
                :data-vv-rules="'required|min_value:0|max_value:100'"
                data-vv-name="stones"
                data-vv-value-path="inputValue"
                data-vv-as="st"
                :errorText="errors.first('stones')"
                type="number"
                label="ST"
                :hintText="$t('message.placeholderText')"
                v-model.number="model.stones"
                :fullWidth="true"
              />
            </mu-col>
            <mu-col width="100" tablet="50" desktop="50" v-if="weight.measure === 'st-lbs'">
              <mu-text-field
                v-validate
                data-vv-validate-on="none"
                min="0"
                max="13"
                :data-vv-rules="'required|min_value:0|max_value:13'"
                data-vv-name="pounds"
                data-vv-value-path="inputValue"
                data-vv-as="lbs"
                :errorText="errors.first('pounds')"
                type="number"
                label="LBS"
                :hintText="$t('message.placeholderText')"
                v-model.number="model.pounds"
                :fullWidth="true"
              />
            </mu-col>
          </mu-row>

          <mu-row>
            <mu-col>
              <image-uploader :title="$t('message.labelAddPhoto')" style="margin-bottom: 16px;" v-if="!model.image"
                              v-model="model.image"></image-uploader>
              <mu-card v-if="model.image" style="margin-bottom: 16px">
                <mu-card-text>
                  <mu-flat-button @click.native="removeImage" icon="close" label="Clear image"></mu-flat-button>
                </mu-card-text>
                <img style="margin-bottom: -6px" v-if="model.image" :src="model.image" width="100%"/>
              </mu-card>
            </mu-col>
          </mu-row>

          <mu-row>
            <mu-col width="100" tablet="100" desktop="100">
              <mu-raised-button v-if="!isInputExpanded" :label="$t('message.labelAdditionalInformation')"
                                icon="expand_more"
                                v-on:click.native="toggleExpandedInput"></mu-raised-button>
              <mu-raised-button v-if="isInputExpanded" label="Close" icon="expand_less"
                                v-on:click.native="toggleExpandedInput"></mu-raised-button>
            </mu-col>
          </mu-row>
          <mu-row v-if="isInputExpanded">
            <mu-col style="margin-top:16px" class="card-sub-header" width="100" tablet="100" desktop="100">
              {{$t('message.cardWeightWaistHipRatio')}}
            </mu-col>
            <mu-col width="50" tablet="50" desktop="50" v-if="waist.measure == 'cm'">
              <mu-text-field
                v-validate
                min="0"
                max="305"
                data-vv-validate-on="none"
                :data-vv-rules="'min_value:0|max_value:305'"
                data-vv-name="waist_cm"
                data-vv-value-path="inputValue"
                data-vv-as="cm"
                :errorText="errors.first('waist_cm')"
                :hintText="$t('message.labelCMPlaceholder')"
                v-model.number="model.waist_cm"
                :label="$t('message.labelWaist')"
                :fullWidth="true"
              />
            </mu-col>
            <mu-col width="50" tablet="50" desktop="50" v-if="waist.measure == 'cm'">
              <mu-text-field
                min="0"
                max="305"
                v-validate
                data-vv-validate-on="none"
                :data-vv-rules="'min_value:0|max_value:305'"
                data-vv-name="hip_cm"
                data-vv-as="cm"
                data-vv-value-path="inputValue"
                :errorText="errors.first('hip_cm')"
                :hintText="$t('message.labelCMPlaceholder')"
                v-model.number="model.hip_cm"
                :label="$t('message.labelHip')"
                :fullWidth="true"
              />
            </mu-col>
            <mu-col width="100" tablet="50" desktop="50" v-if="waist.measure == 'in'">
              <mu-text-field
                v-validate
                min="0"
                max="120"
                data-vv-validate-on="none"
                :data-vv-rules="'min_value:0|max_value:120'"
                data-vv-name="waist_in"
                data-vv-value-path="inputValue"
                data-vv-as="in"
                :errorText="errors.first('waist_in')"
                :hintText="$t('message.labelInchesPlaceholder')"
                v-model.number="model.waist_in"
                :label="$t('message.labelWaist')"
                :fullWidth="true"
              />
            </mu-col>
            <mu-col width="100" tablet="50" desktop="50" v-if="waist.measure == 'in'">
              <mu-text-field
                v-validate
                min="0"
                max="120"
                data-vv-validate-on="none"
                :data-vv-rules="'min_value:0|max_value:120'"
                data-vv-name="hip_in"
                data-vv-as="in"
                data-vv-value-path="inputValue"
                :errorText="errors.first('hip_in')"
                :hintText="$t('message.labelInchesPlaceholder')"
                v-model.number="model.hip_in"
                :label="$t('message.labelHip')"
                :fullWidth="true"
              />
            </mu-col>
          </mu-row>

          <div class="bottom"></div>
          <mu-checkbox v-model="model.customDate" :label="$t('message.labelCustomDate')"></mu-checkbox>
          <date-picker v-if="model.customDate" type="datetime" v-model="model.date"></date-picker>

        </mu-card-text>
        <mu-card-actions align="right">
          <button type="submit" style="display: none;"></button>
          <mu-flat-button
            :label="$t('message.discardText')"
            @click.native="closeInput"
            class="demo-flat-button"
          />
          <mu-flat-button
            @click.native="saveReading"
            type="button"
            :disabled="isSaving"
            :label="isSaving ? $t('message.savingText'): $t('message.saveText')"
            class="demo-flat-button"
          />
        </mu-card-actions>
      </form>
    </transition>

  </mu-card>
</template>
<script>

  import {TweenMax, TweenLite, Power3, ScrollToPlugin} from 'gsap/all'
  import 'gsap/ScrollToPlugin'

  const plugins = [ScrollToPlugin];

  import WeightApi from '../../../../api/Tracking/Weight'
  import SettingsApi from '../../../../api/Settings'
  import ScrollerMixin from '../../../../mixins/ScrollerMixin'
  import CardAnimationMixin from '../../../../mixins/CardAnimationMixin'
  import DatePicker from "../../../DateTimePicker/DateTimePicker.vue";
  import ImageUploader from "../../../ImageUploader/ImageUploader";
  import MuFlexboxItem from "muse-ui/src/flexbox/flexboxItem";
  import MuFlatButton from "muse-ui/src/flatButton/flatButton";

  export default {
    components: {
      MuFlatButton,
      MuFlexboxItem,
      ImageUploader,
      DatePicker
    },
    mixins: [ScrollerMixin, CardAnimationMixin],
    name: 'weight-input',
    props: {
      weight: {},
      waist: {},
      height: {}
    },
    data() {
      return {
        title: this.$t('message.cardWeight'),
        data: {},
        hasData: false,
        isOpenSetting: false,
        isOpenHeightSetting: false,
        isOpenInput: false,
        isInputExpanded: false,
        isSaving: false,
        loading: true,
        settings: {},
        heightSettings: {},
        model: {},
        pusher: null
      }
    },
    mounted() {
      let self = this;
      self.loadData();

      self.$EventBus.$on('weightPusherReceived', function () {
        self.$nextTick(function () {
          self.data = self.$store.state.cards.weight;
          self.$forceUpdate();
        });
      });

      self.$EventBus.$on('weightReadingUpdated', function () {
        self.$store.commit('setWeightCard', {});
        self.loadData();
      });
    },
    methods: {
      removeImage() {
        let self = this;
        delete self.model['image'];
        self.$forceUpdate();
      },
      loadData() {
        let self = this;
        self.loading = true;
        self.isSaving = false;
        self.isOpenSetting = false;
        self.isOpenHeightSetting = false;
        self.isOpenInput = false;


        /**
         * Check if vuex store exists for weight card
         */
        if (_.has(self.$store.state.cards.weight, 'difference')) {
          self.loading = false;
          self.data = self.$store.state.cards.weight;
        } else {
          let getData = WeightApi.getWeightTrackingCard();
          getData.then(function (response) {
            const status = response.status;
            if (status === 200) {
              self.loading = false;
              self.data = response.data;
              self.$store.commit('setWeightCard', response.data);
            } else {
              if (status === 201) {
                self.data = response.data;
                self.loading = false
              } else {
                self.loading = false
              }
            }
          })
        }
      },
      openInput() {
        let self = this;
        self.isOpenInput = !self.isOpenInput;
        if (self.isOpenInput) {
          self.$gtag.event('Open',{
            'event_category': 'WeightCard',
            'event_label': 'Opened card',
            'value': 0
          });
        }
        if (!self.isOpenInput) {
          self.$gtag.event('Closed',{
            'event_category': 'WeightCard',
            'event_label': 'Closed card',
            'value': 0
          });
        }

      },
      closeInput() {
        this.model = {};
        this.isInputExpanded = false;
        this.isOpenInput = false
      },
      openSettings() {
        let self = this;
        if (_.has(self.data, 'no_height_setting')) {
          self.isOpenHeightSetting = true
        } else this.isOpenSetting = true
      },
      closeSettings() {
        this.isOpenSetting = false
      },
      closeHeightSettings() {
        this.isOpenHeightSetting = false
      },
      saveHeightSettings() {
        let self = this;
        self.$validator.validateAll()
          .then(function (valid) {
            if (valid) {
              let canUpdate;
              self.isSaving = true;
              if (self.height.measure === 'ft-in') {
                if (_.has(self.heightSettings, 'ft') && _.has(self.heightSettings, 'in')) {
                  canUpdate = true
                } else canUpdate = false, self.isSaving = false;
              } else {
                if (_.has(self.heightSettings, 'cm')) {
                  canUpdate = true
                } else canUpdate = false, self.isSaving = false;
              }
              if (canUpdate) SettingsApi.updateHeightSettings(self.heightSettings)
                .then(function (response) {
                  self.loadData();
                  self.$EventBus.$emit('lc:settingsUpdated', true);
                }).catch(function (error) {
                  self.isSaving = false
                })
            } else {
              self.isSaving = false;
              canUpdate = false;
            }
          }).catch(function () {
        });

      },
      saveSettings() {
        let self = this;
        self.$validator.validateAll()
          .then(function (valid) {
            if (valid) {
              self.isSaving = true;
              SettingsApi.updateUserSettings(self.settings)
                .then(function () {
                  self.loadData();
                  self.$EventBus.$emit('lc:settingsUpdated', true);
                })
            } else {
              self.isSaving = false;
            }
          })
          .catch(function () {
            self.isSaving = false;
          })
      },
      saveReading() {
        let self = this;
        self.$validator.validateAll()
          .then(function (valid) {
            if (valid) {
              self.isSaving = true;

              if (!_.has(self.model, 'date')) {
                self.model.date = moment().format();
              }

              WeightApi.postWeightTracking(self.model).then(function () {
                self.$store.commit('setWeightCard', {});
                if (self.$route.name === 'Dashboard') {
                  TweenLite.to(self.scroller, 0.2, {
                    scrollTo: {
                      y: self.$el,
                      offsetY: 16
                    }
                  })
                }
                self.$toastr.success(self.$t('message.cardWeightAdded'));
                self.$gtag.event('ReadingAdded',{
                  'event_category': 'WeightCard',
                  'event_label': 'Added reading',
                  'value': 1
                });
                self.model = {};
                self.loadData();
              })
            } else {
              self.isSaving = false;
            }
          })
          .catch(function () {
            self.isSaving = false;
          })
      },
      toggleExpandedInput() {
        let self = this;
        self.isInputExpanded = !self.isInputExpanded;
      },
      goToDetail() {
        let self = this;
        self.$router.push({
          path: '/tracking/weight/'
        })
      }
    },
    beforeDestroy() {
      let self = this;
      self.$EventBus.$off('weightReadingUpdated');
      self.$EventBus.$off('weightPusherReceived');
    }
  }
</script>
<style lang="less">
  @import "./weight.less";
</style>



// WEBPACK FOOTER //
// Weight.vue?0c23cf6d